import classNames from 'classnames'
import styles from './TextButton.module.scss'

export interface LinkButtonProps {
	title: string;
	href: string;
	className?: string;
	rel?: string;
	target?: string;
	iconClass?: string;
}

export const LinkButton = (props: LinkButtonProps) => {
	return (
		<a className={classNames(styles.button, props.className)} href={props.href} rel={props.rel} target={props.target}>
			{
				props.iconClass
					? <i className={classNames(props.iconClass, styles.icon)} />
					: null
			}
			{ props.title }
		</a>
	)
}

